import React, { useEffect } from "react";
import { GSForm, GSSidePanelPage, GSField } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useMatch, useNavigate } from "react-router-dom";

//import scss
import "./tournament-reporting-order-refund.scss";
import { useFormValidation } from "../../../hooks/formHooks";
import {
  useNotificationAction,
  useNotificationBanner,
  useNotificationNavigation,
} from "../../../hooks/notificationHooks";
import { getWarningTitle, warnItemForm } from "../../../forms/DeleteForm";
import { getReportingForm } from "../../../forms/ReportingForm";
import { useSelector } from "react-redux";
import {
  clearNotifications,
  getOrder,
  getOrders,
  refundOrder,
  selectCurrentOrder,
  selectNotifications,
  selectOrderSummary,
} from "../../../reducers/reportingSlice";
import { moneyWithCommas } from "../../../helpers/RegexHelper";
import { useDispatch } from "react-redux";
import { selectCurrentTournament } from "../../../reducers/tournamentSlice";

//Name the component
const TournamentReportingOrderRefund = (props) => {
  const [context, isValid, setIsValid] = useFormValidation(true);
  const match = useMatch("/:tournamentID/reporting/:orderID/refund");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tournament = useSelector(selectCurrentTournament)
  const currentOrder = useSelector(selectCurrentOrder);
  const notifications = useSelector(selectNotifications);
  const tournamentEventOrderSummary = useSelector(selectOrderSummary);
  const availableFunds = tournamentEventOrderSummary?.availableFunds;
  const escrow = tournamentEventOrderSummary?.escrow;

  context.tournament = tournament

  // needed in case someone goes straight to this page via url or refreshes this page
  useEffect(() => {
    if (match?.params?.orderID && currentOrder?.id !== match?.params?.orderID) {
      dispatch(getOrder(match.params.orderID));
    }
  }, [dispatch, match?.params?.orderID, currentOrder?.id]);

  useNotificationNavigation("saved", notifications, -1, "Refund Order");
  useNotificationAction(
    "saved",
    notifications,
    (notification) => {
      dispatch(getOrders(match?.params?.tournamentID));
    },
    "Refund Order"
  );

  const save = () => {
    setIsValid(false);
    dispatch(refundOrder(currentOrder));
  };

  useEffect(() => {
    if (currentOrder?.netProfit > availableFunds && escrow) {
      setIsValid(false);
    }
  }, [currentOrder?.netProfit, availableFunds, escrow, setIsValid]);

  const getDrawerActions = () => {
    let actions = [
      {
        name: "Refund",
        isDisabled: !isValid,
        action: save,
        type: "orange",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: `Refund Details`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle={getWarningTitle("Refund Order")}
        formSections={warnItemForm(
          "Refunds will be made in the form of the original payment. If you need to refund an alternate amount, please contact GolfStatus support.",
          <GSForm
            formTitle={
              <GSField
                type="row emphasize"
                label="Refund Total"
                value={moneyWithCommas(currentOrder?.netProfit)}
              />
            }
            formSections={getReportingForm(context, currentOrder)}
          />
        )}
      ></GSForm>
    );
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const getDrawer = () => {
    return {
      actions: getDrawerActions(),
    };
  };

  const [banner] = useNotificationBanner({ notifications, timeoutAction });

  return (
    //name the component tag
    <tournament-reporting-order-refund>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        drawer={getDrawer()}
      ></GSSidePanelPage>
    </tournament-reporting-order-refund>
  );
};

//export the new namet
export default TournamentReportingOrderRefund;
